export class TriggerHistoryTimeoutStatus {
    static Idle = 0;
    static Running = 1;
    static Timeout = 2;
    static Finished = 3;
}

export class TriggerHistoryCallbackStatus {
    static Idle = 0;
    static Running = 1;
    static Stoped = 2;
    static Finished = 3;
    static Failed = 4;
}

export class TriggerHistoryConstants {
    static TriggerHistoryTimeoutStatusDataSource = [
        { value: TriggerHistoryTimeoutStatus.Idle, label: 'Đang chờ', styleClass: 'idle' },
        { value: TriggerHistoryTimeoutStatus.Running, label: 'Đang chạy', styleClass: 'running' },
        { value: TriggerHistoryTimeoutStatus.Timeout, label: 'Quá timeout', styleClass: 'timeout' },
        { value: TriggerHistoryTimeoutStatus.Finished, label: 'Kết thúc', styleClass: 'finished' }
    ]

    static TriggerHistoryCallbackStatusDataSource = [
        { value: TriggerHistoryCallbackStatus.Idle, label: 'Đang chờ', styleClass: 'idle' },
        { value: TriggerHistoryCallbackStatus.Running, label: 'Đang chạy', styleClass: 'running' },
        { value: TriggerHistoryCallbackStatus.Stoped, label: 'Dừng xử lý', styleClass: 'stoped' },
        { value: TriggerHistoryCallbackStatus.Finished, label: 'Kết thúc', styleClass: 'finished' },
        { value: TriggerHistoryCallbackStatus.Failed, label: 'Xảy ra lỗi', styleClass: 'failed' },
    ]
}